module.exports = __webpack_public_path__ + "static/media/PostcardMockup.68123e21.jpg";